








































import { Vue, Component, Prop } from "vue-property-decorator";

import OrderTable from "@/components/organisms/OrderTable/OrderTable.vue";
import { ExpandMore } from "@/components/icons";

import { Order, OrderHeader, OrderItem } from "@/store/account/orders/types";
import {
  ProductKeys,
  ExtraKeys,
  HeaderKeys,
} from "@/store/account/orders/enums";
import { SortDirections } from "@/store/catalog/enums";
import { calculateTotal } from "@/store/cart/utils";
import { ITableRowExtended } from "@/services/interfaces";
import { pricesModule } from "@/plugins/store-accessors";

interface SortProps {
  key: HeaderKeys;
  order: SortDirections;
}

@Component({
  components: {
    ExpandMore,
    OrderTable,
  },
})
export default class OrderBlock extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  readonly content!: Order;

  @Prop({ type: Boolean, default: false })
  readonly opened!: boolean;

  @Prop({ type: Number, default: 0 })
  readonly index!: number;

  @Prop({ type: Array, default: () => [] })
  readonly headers!: OrderHeader[];

  sort: HeaderKeys | null = null;
  order: SortDirections | null = null;
  sortKey: ProductKeys | null = null;

  get description() {
    let total = 0,
      amount = 0;
    this.content.items.forEach((item) => {
      const sums = calculateTotal(item as any as ITableRowExtended);
      const totalSum = sums.totals.length
        ? sums.totals.reduce((a, b) => a + b)
        : 0;
      const quantity = parseInt(item.quantity as string, 10);

      total += totalSum;
      amount += quantity;
    });
    return `Всего ${amount} ед. товаров ${
      !this.hidePrice ? `, на сумму ${this.totalPurchaseSum.toLocaleString("ru-RU")} ₽` : ""
    }`;
  }

  get totalPurchaseSum() {
    const total = this.content.items.reduce((acc, item) => {
      return acc + Number(item.total);
    }, 0);

    return total;
  }

  get totalSum() {
    const total = this.content.items.reduce((acc, item) => {
      return acc + Number(item.custom_total_price);
    }, 0);

    return total;
  }

  get totalBenefitSum() {
    const benefit = this.content.items.reduce((acc, item) => {
      return acc + Number(item.benefit);
    }, 0);
    return benefit;
  }

  get sortedItems() {
    const key = this.sortKey;
    const order = this.order;
    const initial: OrderItem[] = JSON.parse(JSON.stringify(this.content.items));
    if (!key || !order) {
      return initial;
    }
    return initial.sort(this.sorter(key, order));
  }

  get hidePrice() {
    return pricesModule.getHidePrice;
  }

  sorter(key: ProductKeys, order: SortDirections = SortDirections.DESC) {
    return function (a: OrderItem, b: OrderItem) {
      if (a[key] === b[key]) {
        return 0;
      } else if (a[key] === null || a[key] === undefined) {
        return 1;
      } else if (b[key] === null || b[key] === undefined) {
        return -1;
      } else if (order === SortDirections.ASC) {
        return a[key] < b[key] ? -1 : 1;
      } else {
        return a[key] < b[key] ? 1 : -1;
      }
    };
  }

  sortHandler({ key, order }: SortProps) {
    if (key === this.sort) {
      switch (order) {
        case SortDirections.DESC:
          this.order = SortDirections.ASC;
          break;
        case SortDirections.ASC:
          this.order = null;
          this.sort = null;
          break;
        default:
          this.order = SortDirections.DESC;
          break;
      }
    } else {
      this.sort = key;
      this.order = SortDirections.DESC;
    }
    this.sortAction();
  }

  sortAction() {
    let sortKey;
    switch (this.sort as HeaderKeys) {
      case ExtraKeys.product:
        sortKey = ProductKeys.name;
        break;
      default:
        sortKey = this.sort;
        break;
    }
    this.sortKey = sortKey as ProductKeys;
  }
}
